/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membership_Freeze_Weeks_OneInputs */

const fr_membership_freeze_weeks_one = /** @type {(inputs: Membership_Freeze_Weeks_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 semaine`)
};

/**

* @param {Membership_Freeze_Weeks_OneInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_freeze_weeks_one = /** @type {((inputs?: Membership_Freeze_Weeks_OneInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Freeze_Weeks_OneInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_freeze_weeks_one(inputs)
});